import React, { Component } from 'react';
import {
    Alert, Button, Spinner, Table,
} from 'react-bootstrap';

import { PageStatus } from 'enums';
import { AuthAPI, RedemptionModeAPI } from "../../API";
import { Show } from "../../Layout";
import GridContainer from "../Grid/GridContainer";
import CardHeader from "../Card/CardHeader";
import moment from 'moment'
import { exportToExcel } from "../../Utils/ExportToExcel";
import { Confirmation } from "../../Shared/Confirmation";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import csvtojson from "csvtojson";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import { OtpVerify4RequestApproval } from '../Redemptions/OtpVerification4ApproveRequest';
import { myIpData } from 'Helper/EncryptionDecryption';
import Swal from 'sweetalert2';
import { PORTAL_CODE } from '../../config/portalBranding';
import { formatSmartDate } from "../../Utils/DateFormatter";


const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
};

type State = {
    status: PageStatus,
    error: string | null,
    formType: string,
    redemptions: any[],
    queryId?: string | null,
    filteredData: any,
    filters: any,
    pageSize: any,
    currentPageNumber: any,
    loading: any,
};

class ApproveRequests extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            formType: MODAL_TYPES.NONE,
            redemptions: [],
            queryId: null,
            showManual: false,
            isManual: false,
            isXoXo: false,
            isBulkRejectRequest: false,
            id: '',
            bulkImportData: [],
            filteredData: [],
            currentPage: 1,
            pageSize: 10,
            modes: [],
            filters: {
                requestDate: '',
                redemptionModeTitle: '',
                redemptionRequestStatus: 'Pending(Finance)',
                email: '',
                userId: '',
            },
            currentPageNumber: 1,
            totalResponseData: '',
            totalResponsePages: '',
            loading: false,
            showSingleApprovalOtpModal: false,
            setAmazoneApprovalModal: false,
            showBulkApprovalOtpState: false,
            showAmazoneApprovalModal: false,
            showBulkXoxoApprovalOtpState: false,
            userPhoneNumber: '',
            checkBoxArray: [],
            checkBoxForRejectArray: [],
            setTotalRedemptionPoints: 0,
            setSelectAllCheckBox: false,
            handleApprovalAfterFilterData: true,
            confirmOtp: "",
            setBulkApprovalFunc: false,
        };
    }


    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            (prevState) => ({
                filters: {
                    ...prevState.filters,
                    [name]: value,
                },
            }),
        );
    };

    applyFilters = () => {
        let { redemptionModeTitle } = this.state.filters;
        this.setState({ setSelectAllCheckBox: false, checkBoxArray: [], setTotalRedemptionPoints: 0, checkBoxForRejectArray: [], })
        if (redemptionModeTitle != "") {
            this.setState({ handleApprovalAfterFilterData: false, })
        } else {
            this.setState({ handleApprovalAfterFilterData: true, })
        }
        if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
        this.setState({ currentPageNumber: 1, })
    };

    clearFilter = async () => {
        await new Promise((resolve: any) =>
            this.setState({
                filters: {
                    requestDate: '',
                    redemptionModeTitle: '',
                    redemptionRequestStatus: 'Pending(Finance)',
                    email: '',
                    userId: ''
                },
                pageSize: 10,
                currentPageNumber: 1,
                totalResponseData: '',
                totalResponsePages: '',
                handleApprovalAfterFilterData: true,
                setSelectAllCheckBox: false,
                checkBoxArray: [],
                checkBoxForRejectArray: [],
                setTotalRedemptionPoints: 0,
            }, resolve))
        this.fetchList();
    }


    componentDidMount() {
        this.fetchList()
        this.fetchModes()
    }

    fetchList(): Promise<void> {
        const { pageSize, currentPageNumber, filters } = this.state;
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.redemptionList(pageSize, currentPageNumber, filters))
            .then((users) => {
                let responseData: any = users;
                this.setState({ redemptions: responseData.data, filteredData: responseData.data, totalResponseData: responseData.totalCount, totalResponsePages: responseData.totalPage, status: PageStatus.Loaded, });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    fetchModes = () => {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => RedemptionModeAPI.redemptionList(100))
            .then((surveyData: any) => {
                if (surveyData) {
                    const options = surveyData.map((item) => ({
                        label: item.name,
                        value: item.name,
                    }));
                    this.setState({
                        modes: options,
                        status: PageStatus.Loaded
                    });
                }
            })
            .catch((err) => {
                this.setState({ error: err.message, status: PageStatus.Error });
            });
    };

    async handleExport() {
        const { currentPageNumber, filters } = this.state;
        this.setState({ loading: true });
        try {
            const recievedData = await AuthAPI.redemptionList('All', currentPageNumber, filters);
            exportToExcel(recievedData.data, 'redemptions');
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            this.setState({ loading: false });
        }
    };


    // @ts-ignore
    approvedActions(id, mobile): Promise<void> {
        // Mobile is required only on the India portal (legacy +91 Xoxo path).
        // On non-IN portals (JP/UK/SG/MY/PH) approval must not be blocked by a
        // missing stored phone number.
        const isIN = PORTAL_CODE === 'IN';
        if (isIN ? mobile : true) {
            let obj = {
                id, approvedById: this.props.userId, otp: this.state.confirmOtp, adminflag: "auth"
            }
            return Promise.resolve()
                .then(() => this.setState({ status: PageStatus.Loading }))
                .then(() => AuthAPI.approveRedemptionRequest(obj))
                .then((users) => {
                    alert('Request approved successfully');
                    this.fetchList();
                    this.setState({ id: '', data: users, status: PageStatus.Loaded, showSingleApprovalOtpModal: false, confirmOtp: "" });
                })
                .catch((error) => {
                    this.setState({ error: error.message, status: PageStatus.Error });
                });
        } else {
            alert('Mobile number not available, Please update mobile number')
        }
    }

    rejectActions(id, redeemedPoints): Promise<void> {
        let obj = {
            id, approvedById: this.props.userId, "type": "Finance"
        }
        let newArr = this.state.checkBoxArray;
        let newArray = this.state.checkBoxForRejectArray;
        let newDummyArr = newArr.filter(elem => elem.id != id);
        let newDummyArray = newArray.filter(elem => elem.id != id);
        this.setState((prevState) => {
            const currentPoints = parseInt(prevState.setTotalRedemptionPoints) || 0;
            const newVal = currentPoints !== 0 ? (currentPoints - redeemedPoints) : 0;
            return {
                checkBoxArray: newDummyArr,
                setTotalRedemptionPoints: newVal,
                checkBoxForRejectArray: newDummyArray
            };
        });

        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.rejectRedemptionRequest(obj))
            .then((users) => {
                alert('Request rejected successfully');
                this.fetchList();
                this.setState({ data: users, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }


    approvedActionsBulkManual(): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.manualApprovedBulk({ bulkImportData: this.state.bulkImportData, otp: this.state.confirmOtp, adminflag: "auth", approvedById: this.props.userId }))
            .then((users) => {
                this.fetchList()
                alert('Manual Redemptions Approval Successfully Uploaded')
                return this.setState({ status: PageStatus.Loaded, isManual: false, showBulkApprovalOtpState: false, confirmOtp: "" });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    approvedActionsBulkXoxo(): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.xoxoApprovedBulk({ bulkImportData: this.state.bulkImportData, otp: this.state.confirmOtp, adminflag: "auth", approvedById: this.props.userId }))
            .then((users) => {
                this.fetchList()
                alert('Manual Redemptions Approval Successfully Uploaded')
                return this.setState({ status: PageStatus.Loaded, isXoXo: false, showBulkXoxoApprovalOtpState: false });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    bulkRejectRedeemptionRequests(): Promise<void> {
        let rejectObject = { "rejectList": this.state.bulkImportData, approvedById: this.props.userId, "type": "Finance" };
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.RejectRequestBulk(rejectObject))
            .then((respo) => {
                if (respo.message == "Success!") {
                    this.fetchList();
                    alert('Bulk Rejection Of Redemptions Requests Successfully Uploaded');
                    return this.setState({ status: PageStatus.Loaded, isBulkRejectRequest: false, checkBoxForRejectArray: [], bulkImportData: [], checkBoxArray: [], setTotalRedemptionPoints: 0, });
                }
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    handleFileChange = async (event) => {
        this.setState({ isManual: false, isXoXo: false, isBulkRejectRequest: false, })
        const file = event.target.files[0];
        if (file) {
            try {
                const jsonData = await this.convertCsvToJson(file);
                const transformedData = jsonData.map(this.modifiedConvertedJson);
                this.setState({ bulkImportData: transformedData })
                console.log(transformedData);
            } catch (error) {
                console.error('Error converting CSV to JSON:', error);
            }
        }
    };

    convertCsvToJson = (file: File): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                const csvContent: any = reader.result

                if (!csvContent.trim()) {
                    reject(new Error('CSV content is empty.'));
                    return;
                }

                csvtojson()
                    .fromString(csvContent)
                    .then(jsonData => resolve(jsonData))
            };

            reader.onerror = (event) => {
                const message = reader.error?.message ?? 'Unknown error during file reading';
                reject(new Error(message));
            };

            reader.readAsText(file);
        });
    };

    modifiedConvertedJson = (obj) => {
        if (obj.coupon && obj.pin && this.state.isManual === false) {
            this.setState({ isManual: true })
        } else if (obj.id && obj.type) {
            this.setState({ isBulkRejectRequest: true })
            return { id: obj.id, userId: obj.userId };
        } else if (obj.id && !obj.coupon && !obj.pin && this.state.isXoXo === false) {
            this.setState({ isXoXo: true })
        }
        return {
            id: obj.id,
            userId: this.props.userId,
            coupon: obj.coupon ? myIpData(obj.coupon) : "",
            pin: obj.pin,
            validity: obj.validity,
            approvedById: this.props.userId,
            bulkImportData: []
        };
    }

    handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
    handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

    componentDidUpdate(prevProps: {}, prevState: State) {
        if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
    };

    allCheckboxCheckedFunc = (e: any, arr: []) => {
        if (this.state.handleApprovalAfterFilterData) {
            alert("Please filter redemptions by redemption mode first.");
        } else if (e.target.checked) {
            this.fetchAllPendingStatusList();
        } else {
            this.setState((prevState: any) => {
                return { checkBoxArray: [], setTotalRedemptionPoints: 0, setSelectAllCheckBox: false };
            });
        }
    }

    toggleSelectedCheckbox = (e: any, id: string, arr: [], redeemedPoints: number, obj) => {
        let newArr = this.state.checkBoxArray;
        let newArray = this.state.checkBoxForRejectArray;
        this.setState((prevData: any) => {
            if (e.target.checked) {
                newArr.push({ "id": id });
                newArray.push({ "id": id, "type": "reject" });
                let newVal = parseInt(prevData.setTotalRedemptionPoints) + redeemedPoints;
                return { checkBoxArray: newArr, setTotalRedemptionPoints: newVal, checkBoxForRejectArray: newArray };
            } else {
                let newDummyArr = newArr.filter(elem => elem.id != id);
                let newDummyArray = newArray.filter(elem => elem.id != id);
                let newVal = parseInt(prevData.setTotalRedemptionPoints) - redeemedPoints;
                return { checkBoxArray: newDummyArr, setTotalRedemptionPoints: newVal, setSelectAllCheckBox: false, checkBoxForRejectArray: newDummyArray };
            }
        }
        )
    }

    fetchAllPendingStatusList(): Promise<void> {
        const { filters } = this.state;
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.getstatusFinance(filters))
            .then((respo) => {
                let responseData: any = respo;
                let totalRedemptionPoints = 0;
                let dummyArr = responseData.map((element: any, index: number) => { totalRedemptionPoints += element.pointsRequested; return { "id": element.id }; });
                let dummyNewArr = responseData.map((element: any, index: number) => { return { "id": element.id, "userId": element.userId, "type": "reject" }; });
                this.setState({ status: PageStatus.Loaded, checkBoxArray: dummyArr, checkBoxForRejectArray: dummyNewArr, setTotalRedemptionPoints: totalRedemptionPoints, setSelectAllCheckBox: true });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    approveAllSelectedRequests(): Promise<void> {
        const payloadData = {
            "approvedById": this.props.userId,
            "adminflag": "auth",
            "bulkImportData": this.state.checkBoxArray,
            "otp": this.state.confirmOtp,
        }
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.BothmanualBulkApprove(payloadData))
            .then((respo) => {
                this.setState({ status: PageStatus.Loaded, checkBoxArray: [], setTotalRedemptionPoints: 0, confirmOtp: "", setBulkApprovalFunc: false });
                alert("Redemption requests are approved successfully.");
                this.fetchList();
            })
            .catch((error) => {
                // Show a clean modal instead of dumping the (now sanitized) error
                // into the pink panel. status -> Loaded so the <Alert> won't fire.
                this.setState({ status: PageStatus.Loaded });
                Swal.fire({
                    icon: 'error',
                    title: 'Approval failed',
                    text: error.message || 'Could not complete the redemption approval.',
                });
            });
    }

    rejectBulkRequestsBycheckbox = () => {
        this.setState((prev) => { 
            let newArr = prev.checkBoxForRejectArray.filter(obj => prev.checkBoxArray.some(ele => ele.id === obj.id));
            return { bulkImportData: newArr }
        }, () => { this.bulkRejectRedeemptionRequests() });
    }

    render() {
        const { filteredData, filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages, handleApprovalAfterFilterData } = this.state;
        const tableDataFunc = (value, type) => {
            if (value[type]) { return value[type]; }
            else if (value.redemptionRequestStatus === 'Redeemed') { return 'Delivered'; }
            else { return '-'; }
        }
        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>Redemption Requests</h4>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>
                <OtpVerify4RequestApproval
                    userId={this.props.userId}
                    show={this.state.showManual}
                    onClose={() => this.setState({ showManual: false, id: '', showSingleApprovalOtpModal: false, setAmazoneApprovalModal: false })}
                    onSubmit={(paramOtp) => {
                        this.setState({ showManual: false, confirmOtp: paramOtp })
                        if (this.state.showSingleApprovalOtpModal) {
                            this.approvedActions(this.state.id, this.state.userPhoneNumber);
                        } else if (this.state.setAmazoneApprovalModal) {
                            this.setState({ showAmazoneApprovalModal: true });
                        } else if (this.state.setBulkApprovalFunc) {
                            this.approveAllSelectedRequests();
                        } else if (this.state.showBulkApprovalOtpState) {
                            this.approvedActionsBulkManual();
                        } else if (this.state.showBulkXoxoApprovalOtpState) {
                            this.approvedActionsBulkXoxo();
                        }
                    }}
                />
                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <div className='mb-3'>Filter</div>

                    <form>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='requestDate'>Request Date</label>
                                <input value={filters.requestDate} type="date" name="requestDate" onChange={this.handleFilterChange} className="form-control" placeholder="select date" />
                            </div>
                            <div className="col">
                                <label htmlFor='redemptionModeTitle'>Redemption Mode</label>
                                <select
                                    name='redemptionModeTitle'
                                    id='mode'
                                    value={filters.redemptionModeTitle}
                                    required
                                    onChange={(e) => { this.handleFilterChange(e) }}
                                    style={{
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        lineHeight: '1.5',
                                        color: '#495057',
                                        backgroundColor: '#fff',
                                        backgroundClip: 'padding-box',
                                        border: '1px solid #ced4da',
                                        borderRadius: '5px',
                                        transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                                    }}
                                >
                                    <option key="xyzxyz" value=''>--Choose--</option>
                                    {this.state.modes.length > 0 ? this.state.modes.map((item, index) => (
                                        <option key={"modes" + index} value={item.label}>{item.label}</option>
                                    )) : ''}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='redemptionRequestStatus'>Request Status</label>
                                <select
                                    style={{
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        lineHeight: '1.5',
                                        color: '#495057',
                                        backgroundColor: '#fff',
                                        backgroundClip: 'padding-box',
                                        border: '1px solid #ced4da',
                                        borderRadius: '5px',
                                        transition:
                                            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                    }}
                                    id='gender'
                                    required
                                    name="redemptionRequestStatus"
                                    value={filters.redemptionRequestStatus}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value='Pending(Finance)'>Pending</option>
                                </select>
                            </div>
                            <div className="col">
                                <label htmlFor='userId'>User ID</label>
                                <input type="text" className="form-control" placeholder="User ID"
                                    name="userId"
                                    value={filters.userId}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                        </div>
                    </form>

                    <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
                        <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>Filter Redemptions</button>
                        <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>Export</button>
                        <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>Clear Filter</button>
                        <button type="button" className="btn btn-warning ml-1" onClick={() => this.setState({ showManual: true, setBulkApprovalFunc: true })} disabled={this.state.checkBoxArray.length < 1 || !this.state.redemptions.length}>Approve {this.state.checkBoxArray.length > 0 ? `(${this.state.checkBoxArray.length})` : ""}</button>
                        <Confirmation onAction={() => this.rejectBulkRequestsBycheckbox()} body="Do you want to reject bulk requests ?">
                            <button type="button" className="btn btn-danger ml-1" disabled={this.state.checkBoxArray.length < 1 || !this.state.redemptions.length}>Reject {this.state.checkBoxArray.length > 0 ? `(${this.state.checkBoxArray.length})` : ""}</button>
                        </Confirmation>
                        <div>
                            <input className="mt-2" type="file" accept=".csv" onChange={(e) => this.handleFileChange(e)} />
                        </div>
                        <div>
                            <Button
                                variant="primary"
                                className="mt-3 d-none"
                                size="sm"
                                disabled
                            >
                                Amazon Approve
                            </Button>
                        </div>
                        <div>
                            <Button
                                variant="primary"
                                disabled={this.state.bulkImportData.length === 0 || this.state.isXoXo === false}
                                className="mt-3"
                                size="sm"
                                onClick={() => this.setState({ showManual: true, showBulkXoxoApprovalOtpState: true })}
                            >
                                Approve
                            </Button>
                        </div>
                        <div>
                            <Confirmation onAction={() => this.bulkRejectRedeemptionRequests()} body="Do you want to reject bulk requests ?">
                                <Button
                                    variant="primary"
                                    disabled={this.state.bulkImportData.length === 0 || this.state.isBulkRejectRequest === false}
                                    className="mt-3"
                                    size="sm"
                                >
                                    Bulk Reject Requests
                                </Button>
                            </Confirmation>
                        </div>
                    </div>
                    <div hidden={this.state.setTotalRedemptionPoints == 0}>
                        <h5>Total Requested Points : {this.state.setTotalRedemptionPoints}</h5>
                    </div>
                </div>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>
                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>
                        <Show when={!this.state.filteredData.length}>
                            <Alert variant="info" show={!this.state.redemptions.length}>
                                No data is available
                            </Alert>
                        </Show>

                        <Show when={!!this.state.filteredData.length}>
                            <div className='mb-2'>
                                <ShowDataAccording2PageSize
                                    currentPageSize={pageSize}
                                    currentPage={currentPageNumber}
                                    sendPageSize={this.handlePageSizeChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                                {this.state.loading && (
                                    <img style={{ height: "415px", }}
                                        src="../loadernew.gif"
                                        alt="Loading..."
                                    />
                                )}
                            </div>
                            <Table responsive size="sm" bordered>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className=''>
                                                <div>Select All
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => { this.allCheckboxCheckedFunc(e, this.state.checkBoxArray) }}
                                                            checked={this.state.setSelectAllCheckBox}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </th>
                                        <th>S.No</th>
                                        <th>User Id</th>
                                        <th>Points Redeemed</th>
                                        <th>Points Requested</th>
                                        <th>Mode</th>
                                        <th>Status</th>
                                        <th>Approved By</th>
                                        <th>Request Date</th>
                                        <th>Coupon Code</th>
                                        <th>Pin</th>
                                        <th>Validity</th>
                                        <th>Action Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.map((redemption, index) => (
                                        <tr key={redemption.id}>
                                            <td><input type="checkbox" onChange={(e) => { this.toggleSelectedCheckbox(e, redemption.id, this.state.checkBoxArray, redemption.pointsRequested, redemption) }} id={`checkBox${index}Selected`} checked={(this.state.checkBoxArray.some(obj => obj.id == redemption.id)) || false} disabled={handleApprovalAfterFilterData} /></td>
                                            <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                                            <td>{redemption.userId}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="text-primary bg-transparent"
                                                    onKeyPress={() => null}
                                                    onClick={() => {
                                                        this.setState({
                                                            formType: MODAL_TYPES.NONE,
                                                            queryId: redemption.id,
                                                        });
                                                    }}
                                                >{redemption.pointsRedeemed}</button>
                                            </td>
                                            <td>{redemption.pointsRequested}</td>
                                            <td>{redemption.redemptionModeTitle}</td>
                                            <td>{redemption.redemptionRequestStatus}</td>
                                            <td>{redemption.approvedByRole}</td>
                                            <td>{formatSmartDate(redemption.requestDate)}</td>
                                            <td>
                                                {tableDataFunc(redemption, "coupon")}
                                            </td>
                                            <td>
                                                {tableDataFunc(redemption, "pin")}
                                            </td>
                                            <td>
                                                {tableDataFunc(redemption, "validity")}
                                            </td>
                                            <td>{redemption.actionDate ? formatSmartDate(redemption.actionDate) : "-"}</td>
                                            <td>
                                                <Confirmation onAction={() => this.rejectActions(redemption.id, redemption.pointsRequested)} body="Are you sure want to reject request ?">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        disabled={redemption.redemptionRequestStatus === 'Redeemed'
                                                            || redemption.redemptionRequestStatus === 'Rejected'
                                                            || redemption.redemptionRequestStatus === 'Failed'
                                                        }
                                                        className="mx-1"
                                                    >
                                                        Reject
                                                    </Button>
                                                </Confirmation>
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </Table>
                            <div>
                                <PaginationNumbering
                                    currentPage={currentPageNumber}
                                    returnPagenumber={this.handlePageNumberChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                        </Show>
                    </Show>
                </div>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        userId: state.adminUser.adminUser.userId,
    };
}

const ListWithRouter = withRouter(connect(
    mapStateToProps,
)(ApproveRequests));

export { ListWithRouter as ApproveRequests };
